export const SUBCONTRACTOR_DOCUMENT_CHANGED_EVENT = 'subcontractor-document-changed';
export function dispatchSubcontractorDocumentChanged(detail) {
    window.dispatchEvent(new CustomEvent(SUBCONTRACTOR_DOCUMENT_CHANGED_EVENT, { detail }));
}
